import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function upgrade() {
  return (
    <section className="upgrade result_rodeo p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className=" my-auto resp_order"
          >
            <div className="result_rodeo_img">
              <StaticImage
                src="../../../images/case-studies/rodeo/results.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={637}
                height={644}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1 "
          >
            <h2>Results/Impact</h2>
            <p>
              The implementation of Rodeo Social has significantly improved the
              efficiency of businesses and teams in managing their social media
              presence. The centralized platform has streamlined content
              creation, scheduling, and posting processes, resulting in a more
              organized and coordinated social media strategy. The introduction
              of gamification has likely boosted team engagement and
              competitiveness, positively impacting the quality and frequency of
              published posts.
            </p>
            <p>
              Overall, Rodeo Social contributes to a more effective and
              collaborative approach to social media management, potentially
              enhancing brand visibility and engagement across various
              platforms.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default upgrade;
